import React, { Component, useState } from "react";
import "../css/Menu.css";
import CloseIcon from "@material-ui/icons/Close";
import ListIcon from "@material-ui/icons/List";
import Menuitem from "./Menuitem";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

function showMenu() {
  document.getElementById("menu").style.display = "block";
  document.getElementById("show-btn").style.transition = "all 2s";
}

function closeMenu() {
  document.getElementById("menu").style.display = "none";
}
function Menu() {
  const [menu, setMenu] = useState(false);

  return (
    <div>
      <div id="menu-button">
      {menu ? (
        <div
          id="show-btn"
          onClick={(e) => {
            setMenu(false);
            closeMenu();
          }}
        >
          <CloseIcon style={{   color: "#33658A"
 ,fontSize: 40}} />
        </div>
      ) : (
        <div
          id="show-btn"
          onClick={(e) => {
            setMenu(true);
            showMenu();
          }}
        >
          <ListIcon style={{  color: "#33658A", fontSize: 35}} />
        </div>
      )}

      <div id="menu" style={{ display: "none" }}>
        
            <Link to="/details">
        <Menuitem itemname="ABOUT DOCTOR" />
        </Link>
        <Link to="/appointment">
          <Menuitem itemname="APPOINTMENT" />
        </Link>
        <a href="/address">
          <Menuitem itemname="RESIDENCE ADDRESS" />
        </a>
     
      </div>

      </div>
    </div>
  );
}

export default Menu;
